export default {
  showOrder: (state, id) => {
    return state.account.selected_order == id;
  }
}